import { makeApiCall } from "../apirequest";

export default {
  state: {
    users: [],
    userOrganization: [],
    userPaymentHistory: [],
    organizationId: localStorage.getItem("organizationId") || 0,
  },
  getters: {
    getUsers: (state) => state.users,
    getOrganizationId: (state) => state.organizationId,
    getUserOrganization: (state) => state.userOrganization,
    getUserPaymentHistory: (state) => state.userPaymentHistory,
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_USER_ORGANIZATION(state, userOrganization) {
      state.userOrganization = userOrganization;
    },
    SET_USER_PAYMENT_HISTORY(state, userPaymentHistory) {
      state.userPaymentHistory = userPaymentHistory;
    },
    getOrganizationId({ commit }, id) {
      commit("setOrganizationId", id);
    },
  },
  actions: {
    async getUsers({ commit }, payload) {
      let url = "Admin/GetUsersForAdmin";
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("SET_USERS", response.data.data);
      }
      return response;
    },
    async getUserOrganization({ commit }, payload) {
      const response = await makeApiCall(
        "Admin/GetUserOfOrganization",
        "POST",
        payload
      );
      if (!response.error) {
        commit("SET_USER_ORGANIZATION", response.data.data);
      }
      return response;
    },
    async getUserPaymentHistory({ commit }, payload) {
      const response = await makeApiCall(
        `User/GetUserSubcriptionDetail?UserId=${payload.UserId}`,
        "POST"
      );
      if (
        response &&
        response.data &&
        response.data.succeeded !== false &&
        response.data.data
      ) {
        commit("SET_USER_PAYMENT_HISTORY", response.data.data);
      }
      return response;
    },
    async updateUserStatus(_, payload) {
      const response = await makeApiCall(
        `Admin/users/${payload.userId}/status`,
        "PATCH",
        {
          id: payload.userId,
          isActive: payload.isActive,
        }
      );
      return response;
    },
    async deleteUser(_, payload) {
      const response = await makeApiCall(
        `Admin/user/${payload.userId}`,
        "DELETE"
      );
      return response;
    },
    async createManualSubscription(_, payload) {
      const response = await makeApiCall(
        "Admin/ManualSubscription",
        "POST",
        {
          userId: payload.userId,
          subscriptionType: payload.subscriptionType,
          amount: payload.amount || "0",
        }
      );
      return response;
    },
    setOrganizationId: (state, payload) => {
      state.organizationId = payload;
      localStorage.setItem("organizationId", payload);
    },
  },
};
